(() => {
  if (customElements.get('meubelista-header')) return;

  customElements.define('meubelista-header', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;

      this.main = this.querySelector('.mbh-main');
      this.dialog = this.querySelector('.mbh-dialog');
      this.toggle = this.querySelector('.mbh-mobile-toggle');
      this.desktopToggle = this.querySelector('.mbh-desktop-toggle');
      this.nav = this.querySelector('.mbh-nav');

      if (!this.main || !this.dialog || !this.toggle) return;

      this.events = new AbortController();

      const opts = {
        signal: this.events.signal
      };

      this.mobile = matchMedia('(max-width: 899px)');
      this.icon = this.toggle.innerHTML;
      this.menuOpen = false;
      this.inertNodes = [];
      this.hoverTimers = [];

      this.menus = [
        ...this.querySelectorAll('.mbh-nav-main > li > details')
      ];

      this.dialog.querySelector('.mbh-dialog-top')?.remove();
      this.dialog.querySelector('.mbh-dialog-search')?.remove();

      this.dialog.setAttribute('tabindex', '-1');
      this.dialog.setAttribute('autofocus', '');

      this.extraStyle = document.createElement('style');

      this.extraStyle.textContent = `
        @media (max-width: 899px) {
          .mbh .mbh-main {
            grid-template-areas:
              "menu brand actions"
              "search search search";
            grid-template-columns: 44px minmax(0, 1fr) 44px;
            grid-template-rows: minmax(44px, max-content) auto;
            gap: 8px 10px;
          }

          .mbh .mbh-main .mbh-left {
            display: contents;
          }

          .mbh .mbh-main .mbh-left > .mbh-search {
            grid-area: search;
            display: flex !important;
            width: 100%;
            max-width: none;
          }

          .mbh .mbh-main .mbh-search input {
            font-size: 14px;
          }

          /* De bestaande header blijft binnen het zichtbare scherm. */
          .mbh.mbh-mobile-open .mbh-main {
            position: fixed !important;
            top: var(--mbh-viewport-top, 0px) !important;
            left: var(--mbh-viewport-left, 0px) !important;
            right: auto !important;
            bottom: auto !important;

            width: var(--mbh-viewport-width, 100%) !important;
            max-width: none !important;
            height: auto !important;
            margin: 0 !important;

            z-index: 61;
            background: #fff;
            transition: none !important;
          }

          /* Tijdens zoeken blijft de zoekbalk volledig open. */
          .mbh.mbh-mobile-open .mbh-main .mbh-left > .mbh-search {
            height: 40px !important;
            min-height: 40px !important;
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transition: none !important;
          }

          .mbh.mbh-mobile-open .mbh-main .mbh-search input {
            font-size: 14px !important;
          }

          /* Het menu vult de zichtbare ruimte onder de header. */
          .mbh.mbh-mobile-open .mbh-dialog[open] {
            position: fixed !important;

            top: var(--mbh-menu-top, 120px) !important;
            left: var(--mbh-viewport-left, 0px) !important;
            right: auto !important;
            bottom: auto !important;

            width: var(--mbh-viewport-width, 100%) !important;
            max-width: none !important;
            height: var(
              --mbh-menu-height,
              calc(100dvh - 120px)
            ) !important;
            max-height: none !important;

            z-index: 60;
            margin: 0;
            padding: 0;
            border: 0;
            outline: none;
            overflow: hidden;
            background: #fff;

            animation: mbh-under-header .3s
              cubic-bezier(.22, .61, .36, 1);
          }

          .mbh.mbh-mobile-open .mbh-dialog[open] .mps-panel:not([hidden]) {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-height: none !important;

  display: block !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;

  padding-bottom: calc(
    var(--mbh-keyboard-space, 0px)
    + 16px
    + env(safe-area-inset-bottom)
  ) !important;
}

.mbh.mbh-mobile-open .mbh-dialog[open] .mps-content {
  flex: none !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.mbh.mbh-mobile-open .mbh-dialog[open] .mps-footer {
  position: static !important;
  flex: none !important;
}

.mbh.mbh-mobile-open .mbh-dialog[open] .mbh-dialog-scroll {
  padding-bottom: calc(
    var(--mbh-keyboard-space, 0px)
    + 24px
    + env(safe-area-inset-bottom)
  ) !important;
}

          .mbh .mbh-mobile-toggle:focus {
            outline: none;
            box-shadow: none;
          }

          .mbh .mbh-mobile-toggle:focus,
.mbh .mbh-mobile-toggle:focus-visible {
  outline: none;
  outline-offset: 0;
  box-shadow: none;
}
        }

        @keyframes mbh-under-header {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: none;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .mbh.mbh-mobile-open .mbh-dialog[open] {
            animation: none;
          }
        }
      `;

      this.append(this.extraStyle);

      this.toggle.addEventListener('click', () => {
        if (!this.mobile.matches) return;

        if (this.menuOpen) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      }, opts);

      /*
       * Zet de mobiele header vast zodra het zoekveld focus krijgt,
       * voordat het toetsenbord of de zoekresultaten de layout wijzigen.
       */
      this.main.addEventListener('focusin', event => {
        if (!this.mobile.matches || this.closingMenu) return;

        if (
          !event.target.matches?.('input[type="search"]')
        ) {
          return;
        }

        if (!this.menuOpen) {
          this.openMenu(true);
        } else {
          this.updateLayout();
        }
      }, {
        ...opts,
        capture: true
      });

      /*
       * Houd een resultaat op zijn plek tijdens een tik.
       * Het sluiten van het toetsenbord mag de link niet verplaatsen.
       */
      const releaseViewport = (delay = 0) => {
        clearTimeout(this.viewportReleaseTimer);

        this.viewportReleaseTimer = setTimeout(() => {
          this.resultsPointer = null;
          this.updateLayout();
        }, delay);
      };

      this.dialog.addEventListener('pointerdown', event => {
        if (
          !this.menuOpen ||
          !event.target.closest?.('a[href]')
        ) {
          return;
        }

        clearTimeout(this.viewportReleaseTimer);
        this.resultsPointer = event.pointerId;
      }, opts);

      window.addEventListener('pointerup', event => {
        if (this.resultsPointer === event.pointerId) {
          releaseViewport(350);
        }
      }, opts);

      window.addEventListener('pointercancel', event => {
        if (this.resultsPointer === event.pointerId) {
          releaseViewport();
        }
      }, opts);

      this.dialog.addEventListener('click', () => {
        if (this.resultsPointer != null) {
          releaseViewport();
        }
      }, opts);

      this.desktopToggle?.addEventListener('click', () => {
        const open = this.classList.toggle('mbh-nav-visible');

        this.desktopToggle.setAttribute(
          'aria-expanded',
          String(open)
        );

        if (!open) {
          this.closeDesktop();
        }
      }, opts);

      // Geef de pagina vrij voordat bijvoorbeeld de winkelwagen opent.
      this.main.addEventListener('click', event => {
        if (
          this.menuOpen &&
          event.target.closest?.('a[href]')
        ) {
          this.closeMenu(false);
        }
      }, {
        ...opts,
        capture: true
      });

      this.dialog.addEventListener('close', () => {
        if (this.menuOpen && !this.dialog.open) {
          this.closeMenu();
        }
      }, opts);

      this.addEventListener('keydown', event => {
        if (!this.menuOpen || event.defaultPrevented) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeMenu();
          return;
        }

        if (event.key !== 'Tab') return;

        const selector =
          'a[href], button, input, select, textarea, summary, [tabindex]';

        const items = [
          ...this.main.querySelectorAll(selector),
          ...this.dialog.querySelectorAll(selector)
        ].filter(element => {
          return (
            element.tabIndex >= 0 &&
            !element.disabled &&
            element.getClientRects().length &&
            getComputedStyle(element).visibility !== 'hidden' &&
            !element.closest('[inert]')
          );
        });

        const index = items.indexOf(document.activeElement);

        if (!items.length) {
          event.preventDefault();
        } else if (
          index < 0 ||
          (event.shiftKey && index === 0) ||
          (!event.shiftKey && index === items.length - 1)
        ) {
          event.preventDefault();

          items[
            event.shiftKey ? items.length - 1 : 0
          ].focus();
        }
      }, opts);

      this.menus.forEach(menu => {
        let timer;

        menu.addEventListener('toggle', () => {
          if (menu.open) {
            this.closeDesktop(menu);
          }
        }, opts);

        menu.addEventListener('pointerenter', event => {
          clearTimeout(timer);

          if (
            this.dataset.trigger === 'hover' &&
            event.pointerType === 'mouse' &&
            !this.mobile.matches
          ) {
            this.closeDesktop(menu);
            menu.open = true;
          }
        }, opts);

        menu.addEventListener('pointerleave', () => {
          if (this.dataset.trigger !== 'hover') return;

          clearTimeout(timer);

          timer = setTimeout(() => {
            if (!menu.contains(document.activeElement)) {
              menu.open = false;
            }
          }, 180);

          this.hoverTimers.push(timer);
        }, opts);

        menu.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;

          event.preventDefault();
          menu.open = false;
          menu.querySelector('summary')?.focus();
        }, opts);
      });

      document.addEventListener('pointerdown', event => {
        if (
          !this.nav?.contains(event.target) &&
          !this.desktopToggle?.contains(event.target)
        ) {
          this.closeDesktop();
          this.classList.remove('mbh-nav-visible');

          this.desktopToggle?.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      }, opts);

      const update = () => {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateLayout();
        });
      };

      window.addEventListener('scroll', update, {
        ...opts,
        passive: true
      });

      window.addEventListener('resize', update, opts);

      window.visualViewport?.addEventListener(
        'resize',
        update,
        opts
      );

      window.visualViewport?.addEventListener(
        'scroll',
        update,
        opts
      );

      this.mobile.addEventListener('change', () => {
        this.closeMenu(false);
        this.updateLayout();
      }, opts);

      window.addEventListener('pageshow', () => {
        this.closeMenu(false);
        this.updateLayout();
      }, opts);

      this.observer = new ResizeObserver(update);
      this.observer.observe(this);
      this.observer.observe(this.main);

      this.updateLayout();
    }

    openMenu(keepSearchFocus = false) {
      if (this.menuOpen || !this.mobile.matches) return;

      clearTimeout(this.closeTimer);
      this.closingMenu = false;

      const focused = document.activeElement;

      // Bewaar de scrollpositie voordat de pagina wordt vastgezet.
      this.scrollPosition = {
        x: window.scrollX,
        y: window.scrollY
      };

      this.menuOpen = true;
      this.closeDesktop();
      this.classList.remove('mbh-search-hidden');

      // Houd de oorspronkelijke ruimte van de header in de pagina bezet.
      this.placeholder = document.createElement('div');
      this.placeholder.setAttribute('aria-hidden', 'true');

      this.placeholder.style.cssText =
        'display:block;pointer-events:none;';

      this.placeholder.style.height =
        Math.ceil(this.main.getBoundingClientRect().height) + 'px';

      this.main.before(this.placeholder);

      this.classList.add('mbh-mobile-open');
      this.updateLayout();

      this.savedStyles = [
        [document.documentElement, 'overflow', 'hidden'],
        [document.body, 'position', 'fixed'],
        [document.body, 'top', -this.scrollPosition.y + 'px'],
        [document.body, 'left', -this.scrollPosition.x + 'px'],
        [document.body, 'width', '100%'],
        [document.body, 'overflow', 'hidden']
      ].map(([element, property, value]) => {
        const saved = [
          element,
          property,
          element.style.getPropertyValue(property),
          element.style.getPropertyPriority(property)
        ];

        element.style.setProperty(property, value);

        return saved;
      });

      // De header blijft bedienbaar; de pagina erachter niet.
      for (
        let node = this;
        node.parentElement && node !== document.body;
        node = node.parentElement
      ) {
        for (const sibling of node.parentElement.children) {
          if (
            sibling === node ||
            sibling.inert ||
            ['STYLE', 'SCRIPT', 'LINK'].includes(sibling.tagName)
          ) {
            continue;
          }

          sibling.inert = true;
          this.inertNodes.push(sibling);
        }
      }

      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggle.setAttribute('aria-label', 'Menu sluiten');

      this.toggle.innerHTML = `
        <svg
          width="23"
          height="23"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="m6 6 12 12M18 6 6 18"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
      `;

      // Behoud tijdens zoeken de focus op hetzelfde inputveld.
      if (keepSearchFocus) {
        this.dialog.removeAttribute('autofocus');
      }

      this.dialog.show();
      this.dialog.setAttribute('autofocus', '');

      if (keepSearchFocus && focused?.isConnected) {
        if (document.activeElement !== focused) {
          focused.focus({
            preventScroll: true
          });
        }
      } else {
        this.dialog.focus({
          preventScroll: true
        });
      }

      this.updateLayout();
    }

    closeMenu(focus = true) {
      if (!this.menuOpen) return;

      this.closingMenu = true;
      this.menuOpen = false;

      clearTimeout(this.viewportReleaseTimer);
      this.resultsPointer = null;

      this.querySelector(
        'meubelista-predictive-search'
      )?.dismiss?.();

      const focused = document.activeElement;

      if (
        focused?.matches?.('input[type="search"]') &&
        this.main.contains(focused)
      ) {
        focused.blur();
      }

      if (this.dialog.open) {
        this.dialog.close();
      }

      this.dialog.classList.remove(
        'mps-search-mode',
        'mps-searching'
      );

      this.classList.remove('mbh-mobile-open');

      this.placeholder?.remove();
      this.placeholder = null;

      this.toggle.innerHTML = this.icon;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-label', 'Menu openen');

      this.inertNodes.forEach(element => {
        element.inert = false;
      });

      this.inertNodes = [];

      (this.savedStyles || []).forEach(
        ([element, property, value, priority]) => {
          if (value) {
            element.style.setProperty(
              property,
              value,
              priority
            );
          } else {
            element.style.removeProperty(property);
          }
        }
      );

      this.savedStyles = [];

      window.scrollTo({
        left: this.scrollPosition.x,
        top: this.scrollPosition.y,
        behavior: 'instant'
      });

      this.searchLastY = this.scrollPosition.y;
      this.searchDirection = 0;
      this.searchTravel = 0;
      this.searchPauseUntil = performance.now() + 280;

      if (focus && this.toggle.isConnected) {
        this.toggle.focus({
          preventScroll: true
        });
      }

      this.updateLayout();

      this.closeTimer = setTimeout(() => {
        this.closingMenu = false;
      }, 0);
    }

    closeDesktop(except) {
      this.menus?.forEach(menu => {
        if (menu !== except) {
          menu.open = false;
        }
      });
    }

    updateLayout() {
      if (!this.main) return;

      const y = Math.max(
        0,
        this.menuOpen
          ? this.scrollPosition.y
          : window.scrollY
      );

      const search = this.main.querySelector('.mbh-search');

      const keepSearch =
        !this.mobile.matches ||
        this.menuOpen ||
        search?.contains(document.activeElement) ||
        y < 80;

      if (keepSearch) {
        this.classList.remove('mbh-search-hidden');
        this.searchLastY = null;
        this.searchDirection = 0;
        this.searchTravel = 0;
        this.searchPauseUntil = 0;
      } else {
        const previous = this.searchLastY ?? y;
        this.searchLastY = y;

        const delta = y - previous;

        if (performance.now() < (this.searchPauseUntil || 0)) {
          this.searchDirection = 0;
          this.searchTravel = 0;
        } else if (delta !== 0) {
          const direction = Math.sign(delta);

          this.searchTravel = direction === this.searchDirection
            ? (this.searchTravel || 0) + Math.abs(delta)
            : Math.abs(delta);

          this.searchDirection = direction;

          if (this.searchTravel >= 12) {
            const hide = direction > 0;

            if (
              hide !== this.classList.contains('mbh-search-hidden')
            ) {
              this.classList.toggle(
                'mbh-search-hidden',
                hide
              );

              this.searchPauseUntil = performance.now() + 280;
            }

            this.searchTravel = 0;
          }
        }
      }

      if (
        this.mobile.matches &&
        this.menuOpen &&
        this.resultsPointer == null
      ) {
        const viewport = window.visualViewport;

        const top = Math.max(
          0,
          viewport?.offsetTop || 0
        );

        const left = Math.max(
          0,
          viewport?.offsetLeft || 0
        );

        const width =
          viewport?.width ||
          document.documentElement.clientWidth;

        const height =
          viewport?.height ||
          window.innerHeight;

        this.style.setProperty(
          '--mbh-viewport-top',
          top + 'px'
        );

        this.style.setProperty(
          '--mbh-viewport-left',
          left + 'px'
        );

        this.style.setProperty(
          '--mbh-viewport-width',
          width + 'px'
        );

        const headerHeight = Math.ceil(
          this.main.getBoundingClientRect().height
        );

        if (this.placeholder) {
          this.placeholder.style.height =
            headerHeight + 'px';
        }

        this.style.setProperty(
          '--mbh-menu-top',
          (top + headerHeight) + 'px'
        );

        const layoutHeight = Math.max(
  document.documentElement.clientHeight || window.innerHeight,
  window.innerHeight,
  height
);

this.style.setProperty(
  '--mbh-menu-height',
  Math.max(0, layoutHeight - headerHeight) + 'px'
);

this.style.setProperty(
  '--mbh-keyboard-space',
  Math.max(0, layoutHeight - height) + 'px'
);
      } else if (!this.menuOpen) {
        this.style.setProperty(
          '--mbh-menu-top',
          Math.max(
            0,
            this.main.getBoundingClientRect().bottom
          ) + 'px'
        );
      }

      if (!this.menuOpen) {
        const wasCompact = this.classList.contains('mbh-compact');

        const compact = !this.mobile.matches && (
          wasCompact ? y > 30 : y > 160
        );

        this.classList.toggle('mbh-compact', compact);

        if (wasCompact !== compact) {
          this.classList.remove('mbh-nav-visible');

          this.desktopToggle?.setAttribute(
            'aria-expanded',
            'false'
          );

          this.closeDesktop();
        }
      }

      if (this.isConnected) {
        document.documentElement.style.setProperty(
          '--header-height',
          Math.ceil(this.getBoundingClientRect().height) + 'px'
        );
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();

      if (this.menuOpen) {
        this.closeMenu(false);
      }

      cancelAnimationFrame(this.frame);
      this.hoverTimers?.forEach(clearTimeout);

      clearTimeout(this.closeTimer);
      clearTimeout(this.viewportReleaseTimer);

      this.extraStyle?.remove();
      this.events = null;
    }
  });
})();